import { Section } from '@/components/Section';

export function LocationPage() {
  return (
    <Section eyebrow="Location" title="Visit the gym.">
      <div className="relative mb-10 aspect-video overflow-hidden rounded-lg border border-bone/10 bg-neutral-900">
        <video
          src="/video/gym-loop.mp4"
          poster="/video/gym-loop-poster.jpg"
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          aria-label="Class training at George Prevalsky's gym"
          className="absolute inset-0 h-full w-full object-cover"
        />
      </div>
      <div className="grid gap-8 md:grid-cols-2">
        <div>
          <p className="font-display text-2xl">
            George Prevalsky&apos;s Boxing &amp; Muay Thai Gym
          </p>
          <p className="mt-3 text-bone/80">
            612 Valley Ranch Pkwy S<br />
            Irving, TX 75063
          </p>
          <p className="mt-3 text-sm text-bone/60">
            Southeast corner of MacArthur Blvd &amp; Valley Ranch Pkwy South. Next to Discount Tire
            and behind CVS, about 2 blocks north of I-635. 6,000 sq.ft. standalone facility.
          </p>
          <a
            href="https://www.google.com/maps/dir/?api=1&destination=612+Valley+Ranch+Pkwy+S,+Irving,+TX+75063"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-ghost mt-6 inline-block"
          >
            Get directions →
          </a>

          <div className="mt-8">
            <p className="text-xs uppercase tracking-wider text-accent">Hours</p>
            <dl className="mt-3 grid grid-cols-[5rem_1fr] gap-y-1 text-sm text-bone/80">
              <dt>Monday</dt>
              <dd>5:30 PM - 9:30 PM</dd>
              <dt>Tuesday</dt>
              <dd>11:30 AM - 9:30 PM</dd>
              <dt>Wednesday</dt>
              <dd>5:30 PM - 9:30 PM</dd>
              <dt>Thursday</dt>
              <dd>11:30 AM - 9:30 PM</dd>
              <dt>Friday</dt>
              <dd>6:20 PM - 8:00 PM</dd>
              <dt>Saturday</dt>
              <dd>9:30 AM - 2:30 PM</dd>
              <dt>Sunday</dt>
              <dd className="text-bone/50">Closed</dd>
            </dl>
          </div>
        </div>
        <div className="aspect-[4/3] overflow-hidden rounded-lg border border-bone/10 bg-neutral-900/40 md:aspect-auto">
          <iframe
            title="Map - 612 Valley Ranch Pkwy S, Irving, TX"
            src="https://www.google.com/maps?q=612+Valley+Ranch+Pkwy+S,+Irving,+TX+75063&output=embed"
            className="h-full min-h-[320px] w-full"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </Section>
  );
}
